/**
 * No-op MSAL stub for platform-public (unauthenticated Customer Portal).
 * Public site does not use authentication; this provides the same API shape as
 * @azure/msal-react so components that call useMsal() / use templates don't throw.
 * No @azure/msal-browser or @azure/msal-react code runs.
 */

import React, { createContext, useContext } from 'react';

const stubValue = {
  instance: null,
  accounts: [],
  inProgress: 'none',
};

const MsalContext = createContext(stubValue);

export function useMsal() {
  const context = useContext(MsalContext);
  return context != null ? context : stubValue;
}

/** No-op: just renders children. Public site has no auth. */
export function MsalProvider({ children }) {
  return React.createElement(MsalContext.Provider, { value: stubValue }, children);
}

/** Public site is unauthenticated: always show children. */
export function UnauthenticatedTemplate({ children }) {
  return children ?? null;
}

/** Public site: never "authenticated", so render nothing. */
export function AuthenticatedTemplate({ children }) {
  return null;
}

/** No-op: render children (no login redirect on public). */
export function MsalAuthenticationTemplate({ children }) {
  return children ?? null;
}
